<template>
  <b-app :dark="dark" :style="{ backgroundColor: site_background }">

    <template v-slot:navigation>
      <v-app-bar
        app
        dark
        color="primary"
        dense
        elevate-on-scroll
      >
        <v-toolbar-title>{{ $t("top_bar.title") }}</v-toolbar-title>

        <v-spacer></v-spacer>

<!--        <v-btn-->
<!--          icon-->
<!--          :dark="dark"-->
<!--          @click="finish"-->
<!--        >-->
<!--          <v-icon>mdi-account-supervisor-circle-outline</v-icon>-->
<!--        </v-btn>-->

<!--        <b-language-dropdown />-->

<!--        <v-btn-->
<!--          v-if="!logged_in"-->
<!--          :dark="dark"-->
<!--          icon-->
<!--          @click="$router.push({ path: 'login' })"-->
<!--        >-->
<!--          <v-icon>mdi-login</v-icon>-->
<!--        </v-btn>-->
<!--        <b-logout v-else />-->
      </v-app-bar>
    </template>

    <template v-slot:default>
      <v-container fluid>
        <v-row
          no-gutters
        >
          <v-col
            cols="12"
            lg="10"
            offset-lg="1"
            xl="8"
            offset-xl="2"
          >
            <router-view v-if="!config_error"/>
            <b-error-alert v-model="config_error" :message="error_message"/>
            <b-development-banner
              :visible="dev_mode"
            >
              <b-language-debug-toggle
                class="debug ml-6"
              />
            </b-development-banner>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:footer>
      <div class="footer">
        <p v-html="$t('developed_by')"/>
      </div>
    </template>

  </b-app>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "App",
  data: () => ({
    config_error: false,
    error_message: "",
    dark: !!window.bomconfig.darkmode,
  }),
  created() {
    if (!window.bomconfig) {
      this.setError(this.$t("b.error.no_bom_config"));
      return;
    }
    this.assertRequiredConfigs();
    if (window.bomconfig.color) {
      this.$bomify.$vuetify.theme.themes.light.primary = window.bomconfig.color;
      this.$bomify.$vuetify.theme.themes.dark.primary = window.bomconfig.color;
    }
    if (window.bomconfig.add_modules) {
      window.bomconfig.add_modules.forEach((module_definition) => {
        if (!this.$bom[module_definition.name]) {
          this.$bom.addModule(module_definition);
        }
      });
    }
  },
  computed: {
    dev_mode() {
      return !window.bomconfig.production;
    },
    ...mapGetters("config", {
      getThemeVariable: "getThemeVariable",
    }),
    ...mapGetters("auth", {
      logged_in: "isLoggedIn",
    }),
    site_background() {
      return this.getThemeVariable("site_background");
    },
  },
  methods: {
    assertRequiredConfigs() {
      const required_config_keys = [
        "api_url",
        "api_token",
        "client_id",
        "module",
      ];
      required_config_keys.forEach((required_key) => {
        this.assertConfig(required_key);
      });
    },
    assertConfig(entry) {
      if (!window.bomconfig[entry]) {
        this.setError(this.$t("b.error.missing_config_entry", { entry }));
      }
    },
    setError(message) {
      this.config_error = true;
      this.error_message = `ERROR: ${message}`;
    },
  },
};
</script>

<style>
div.footer {
  padding-top: 30px;
  width: 100%;
}
div.footer > p {
  width: 100%;
  text-align: center;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 0.8rem;
  color: grey;
}
div.footer >>> p * {
  color: grey;
  text-decoration: none;
}
.debug >>> .v-label {
  color: black;
  font-size: 16px;
}
.debug >>> .v-input--selection-controls__input * {
  font-size: 20px;
}
</style>
